interface BadgeProps {
  variant?:
  | 'primary'
  | 'success'
  | 'info'
  | 'danger'
  | 'disabled'
  | 'default'
  | 'warning'
  | 'soon'
  | 'zoom'
  | 'meet'
  | 'teams';
  children: React.ReactNode;
  className?: string;
}

const Badge = ({ variant = 'default', children, className }: BadgeProps) => {
  const variantStyles = {
    primary: 'bg-primary-500 text-white',
    success: 'bg-success-500/50',
    info: 'bg-secondary-600',
    danger: 'bg-red-300',
    disabled: 'bg-trueGray-300 dark:bg-white',
    default: 'bg-content3',
    warning: 'bg-warning text-black',
    soon: 'bg-content3',
    zoom: 'bg-[#458CFF] text-white',
    meet: 'bg-[#00832D] text-white',
    teams: 'bg-[#4B53BC] text-white'
  };

  const styles = variantStyles[variant] || variantStyles.default;

  return (
    <span
      className={`${styles} flex items-center select-none text-xs font-medium tracking-wide px-1 py-0.5 rounded-[3px] ${className || ''}`}
    >
      {children}
    </span>
  );
};

export default Badge;
